
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/builder/page",
      function () {
        return require("private-next-pages/builder/page.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/builder/page"])
      });
    }
  